import React, { Component } from 'react';
import { uniqBy } from 'lodash'


class Tabs extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    getCount=(data,competitorId) =>{
        let count = 0;
        data.map(item=>{
            if(item.competitorId === competitorId){
                count+=item.score
            }
        })
        return count
    }
    render() {
        let tabs = [];

        this.props.tabs.map((item, key) => {
            this.props.compete.customerSegmentData.map(comp => {
                comp.segments.map(segments => {
                    if (item.groupId === comp.groupId && item.segmentId === segments.segmentId) {
                        tabs.push(
                            <li className="nav-item" key={`${item.groupId + `id` + item.segmentId}`}>
                                <a data-toggle="tab" className={key === 0 ? "nav-link active show" : "nav-link"} href={`#${item.groupId + `id` + item.segmentId}`} aria-controls={`${item.groupId + `id` + item.segmentId}`} aria-selected="true">{comp.groupName + ` - ` + segments.name} <i className="fa fa-minus minus-icon"
                                    onClick={() => this.props.onDelete(item.groupId, item.segmentId)}
                                ></i></a>
                            </li>)
                    }
                })
            })

        });
        let tabsContent = this.props.tabs.map((tabItem, key) => {
            let productValue = 0;
            let countConpenScore = [];
            return (
               
                <div id={tabItem.groupId + `id` + tabItem.segmentId} className={key === 0 ? "tab-pane fade show active tabContentdiv positioning-tab-content priceValue" : "tab-pane fade tabContentdiv compete-tab-content positioning-tab-content priceValue"} role="tabpanel" key={key}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="header">
                                <div className="name"></div>
                                <div className="price"><span style={{ fontWeight: "bold" }}>Price</span></div>
                                <div className="score"><span style={{ fontWeight: "bold" }}>Score <br /><span style={{ fontSize: "12px" }}>(Ability to Compete)</span></span></div>
                            </div>
                            <div className="listview">
                                {uniqBy(tabItem.competitors, r=> r.competitorId).map((comp, key) => {
                                    let CompetitorName = this.props.competitiveAnalysis.competitorsGroupsData.Items[0].competitors.map(item => {
                                        if (comp.competitorId === item.competitorId) {
                                            return item.competitorName
                                        }
                                    })
                                    this.props.compete.competeData.Items[0].dataBenefits.map(benefit => {
                                        if (tabItem.groupId === benefit.groupId && tabItem.segmentId === benefit.segmentId) {
                                            benefit.criticalCapacity.map((critItem, index) => {
                                                let rateVal = critItem.competitors ? critItem.competitors.find(r => r.competitorId === comp.competitorId) : { rating: '1' };
                                                let valScore = rateVal ? +critItem.ccWt * +rateVal.rating : +critItem.ccWt;
                                                countConpenScore.push({
                                                    score: valScore,
                                                    competitorId: comp.competitorId
                                                })
                                            })
                                        }
                                    })
                                    return <div className="item" key={key}>
                                        <div className="name">{CompetitorName}</div>
                                        <div className="price">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    value={comp.price}
                                                    className="form-control"
                                                    onChange={(e) => this.props.onCompetitorPriceChange(tabItem.groupId, tabItem.segmentId, e.target.value, comp.competitorId)}
                                                />
                                            </div>
                                        </div>
                                        <div className="score">{this.getCount(countConpenScore,comp.competitorId)}</div>
                                    </div>
                                })}
                                <div className="item">
                                    <div className="name">{this.props.challengeStatement.getChallengeStatementData.Items[0].chalange.horizon1.company}</div>
                                    <div className="price">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                value={tabItem.product.price}
                                                className="form-control"
                                                onChange={(e) => this.props.onProductPriceChange(tabItem.groupId, tabItem.segmentId, e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    {this.props.compete.competeData.Items[0].dataBenefits.map(benefit => {
                                        if (tabItem.groupId === benefit.groupId && tabItem.segmentId === benefit.segmentId) {
                                            productValue += benefit.totalScore
                                        }
                                    })}
                                    <div className="score">{productValue}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )

        })
        return (
            <div className='criteria-tabs-content attractiveness-tab-content'>
                <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                    <li className="nav-item">
                        <a id='plusTab' onClick={() => this.props.createTabModal()}
                        ><i className="fa fa-plus plusbtn plus-icon"></i></a>
                    </li>
                    {tabs}
                </ul>
                <div className="tab-content benefitsTabcontent" id="myTabContent" >
                    {tabsContent}
                </div>
            </div>
        )
    }
}

export default (Tabs);



// WEBPACK FOOTER //
// ./src/components/PricingValueComponent/Step1/Tabs/Tabs.jsx